import { useMemo, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { Billboard, Html, Line, Text } from "@react-three/drei";
import { MeshLineMaterial } from "meshline";
import { useTranslation } from "react-i18next";
import { extend } from "@react-three/fiber";
import { types } from "@theatre/core";
import { degToRad } from "three/src/math/MathUtils";
import { Select } from "@react-three/postprocessing";
import { Vector3 } from "three";

extend({ MeshLineMaterial });

const MeasureLabel = forwardRef(({ label, instanceName, ...props }, ref) => {
  const { t } = useTranslation();
  const lineShader = useRef();

  const lineRef = useRef();
  const textRef1 = useRef();
  const textRef2 = useRef();

  useImperativeHandle(ref, () => ({
    fadeIn: (v) => {
      if (lineRef.current) {
        lineRef.current.material.opacity = v;
        textRef1.current.material.opacity = v;
        textRef2.current.material.opacity = v;
      }
    },
  }));

  const lineMaterial = useMemo(() => {
    var mat = new MeshLineMaterial({
      transparent: true,
      color: 0xd6d6d6,
      lineWidth: 0.000275,
      depthTest: true,
    });

    const onBeforeCompile = (shader) => {
      shader.uniforms = { ...shader.uniforms, fadeIn: { value: 0 } };
      shader.fragmentShader = "uniform float fadeIn;\n" + shader.fragmentShader;
      shader.fragmentShader = shader.fragmentShader.replace(
        `#endif
}`,
        `#endif
    gl_FragColor.a = fadeIn;
  }`,
      );
      lineShader.current = shader;
    };

    mat.onBeforeCompile = onBeforeCompile;

    return mat;
  }, []);

  const linePoints = useMemo(() => {
    var points = [new Vector3(0, 0, 0)];

    const lineLength = 0.5;
    const underLineLength = 0.2;

    if (label.userData.right) {
      var point1 = new Vector3(-lineLength, -lineLength, 0);
      points.push(point1);
      var point2 = point1.clone().add(new Vector3(-underLineLength, 0, 0));
      points.push(point2);
    } else {
      var point1 = new Vector3(lineLength, lineLength, 0);
      points.push(point1);
      var point2 = point1.clone().add(new Vector3(underLineLength, 0, 0));
      points.push(point2);
    }

    return points;
  }, []);

  return (
    <group
      position={[
        // label.userData.right ? 0.75 : 0,
        label.position.x,
        label.position.y,
        label.position.z,
      ]}
      rotation={label.rotation}
    >
      <group rotation={[0, 0, 0]}>
        <Line points={linePoints} color="#d6d6d6" linewidth={0.5} transparent ref={lineRef} />

        <Text
          position={linePoints[1]}
          anchorX={label.userData.right ? "right" : "left"}
          anchorY="bottom"
          fontSize={0.075}
          color="#d6d6d6"
          rotation={[0, 0, 0]}
          ref={textRef1}
          // fillOpacity={
          //   animationValues !== undefined ? animationValues.TextOpacity : 0
          // }
        >
          <meshStandardMaterial attach="material" toneMapped={false} transparent />
          {t(props.textid)}
        </Text>

        <Text
          position={linePoints[1]}
          rotation={[degToRad(180), 0, degToRad(180)]}
          anchorX={label.userData.right ? "left" : "right"}
          anchorY="bottom"
          fontSize={0.075}
          color="#fff"
          ref={textRef2}
        >
          <meshStandardMaterial attach="material" toneMapped={false} transparent />
          {t(props.textid)}
        </Text>
      </group>
    </group>
  );
});

export default MeasureLabel;
